import Component from '../../classes/Component';
import {$dom} from '../../helpers/dom';
import variables from '../../variables';
import {$events} from "../../helpers/events";
import {gsap} from 'gsap';
import Choices from 'choices.js';
import {isElement} from "../../helpers/_utilities";

const withOtherFieldSelectSelector = '.js-custom-select-with-other-field';
const boundOtherFieldAttr = 'data-other-select-id';
const selectOtherSelector = '.js-select-other';

const getIcon = name => `<svg class="svg-icon"><use xlink:href="#${name}"/></svg>`;
export default function () {

	return new Component({
		name: 'select',
		requiredTargets: variables.selectors.select,
		onCreate() {
            this.fields = {};
        },
		onInit() {
            this.addField = field => {
                const fieldId = $dom.attr(field, 'id');

                if (Choices) {
                    let searchEnabled = true;
                    const searchEnabledAttr = $dom.attr(field, 'data-search-enabled');
                    const position = $dom.attr(field, 'data-select-position') || 'auto';
                    const withCustomIcon = Boolean($dom.attr(field, 'data-custom-select-icon'));
                    const withRemoveButton = Boolean($dom.attr(field, 'data-select-remove-button'));

                    if (searchEnabledAttr)
                        searchEnabled = searchEnabledAttr !== 'false';

                    const choicesParams = {
                        ...variables.choicesOptions,
                        placeholder: false,
                        searchEnabled,
                        position
                    }

                    if (withCustomIcon) {
                        choicesParams.callbackOnCreateTemplates = function(template, t) {
                            return {
                                item: ({ classNames }, data) => {
                                    const withIcon = Boolean(data.customProperties?.icon);
                                    let icon = withIcon
                                        ? getIcon(data.customProperties.icon)
                                        : '';

                                    return template(`
                                        <div class="${classNames.item} ${
                                                        data.highlighted
                                                            ? classNames.highlightedState
                                                            : classNames.itemSelectable
                                                    } ${
                                                        data.placeholder
                                                            ? classNames.placeholder
                                                            : ''
                                                    }"
                                            data-item
                                            data-id="${data.id}"
                                            data-value="${data.value}" ${
                                                        data.active
                                                            ? 'aria-selected="true"'
                                                            : ''
                                                    } ${
                                                        data.disabled
                                                            ? 'aria-disabled="true"'
                                                            : ''
                                                    }
                                        >
                                            ${
                                                        withIcon
                                                            ? icon
                                                            : ''
                                                    }
                                            ${data.label}
                                        </div>
                                    `);
                                },
                                choice: ({ classNames }, data) => {
                                    const withIcon = Boolean(data.customProperties?.icon);
                                    let icon = withIcon
                                        ? getIcon(data.customProperties.icon)
                                        : '';

                                    return template(`
                                        <div
                                            class="${classNames.item} ${classNames.itemChoice} ${
                                                        data.disabled
                                                            ? classNames.itemDisabled
                                                            : classNames.itemSelectable
                                                    }"
                                            data-select-text="${this.config.itemSelectText}" data-choice ${
                                                        data.disabled
                                                            ? 'data-choice-disabled aria-disabled="true"'
                                                            : 'data-choice-selectable'
                                                    }
                                            data-id="${data.id}"
                                            data-value="${data.value}" ${
                                                        data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
                                                    }
                                        >
                                            ${
                                                        withIcon
                                                            ? icon
                                                            : ''
                                                    }
                                            ${data.label}
                                        </div>
                                    `);
                                },
                            };
                        }
                    }

                    if (withRemoveButton) {
                        choicesParams.removeItemButton = true
                    }

                    this.fields[fieldId] = new Choices(field, choicesParams);

                    return this.fields[fieldId]
                }

                return null;
            }

            this.otherField = {
                getBound(selectEl) {
                    let field = null, parent = null;
                    const fieldSelector = `[${boundOtherFieldAttr}="${selectEl.getAttribute('id')}"]`;

                    if ($dom.exist(fieldSelector)) {
                        field = $dom.get(fieldSelector);

                        parent = $dom.getParent(field, selectOtherSelector);
                    }

                    return {field, parent}
                },
                show(selectEl) {
                    if (!isElement(selectEl)) return;

                    if (!selectEl.savedNameAttr)
                        selectEl.savedNameAttr = selectEl.getAttribute('name');

                    const {field, parent} = this.getBound(selectEl);

                    if (field && parent && selectEl.savedNameAttr) {
                        $dom.removeClass(parent, 'd-none');
                        field.setAttribute('name', selectEl.savedNameAttr);
                        selectEl.removeAttribute('name');

                        gsap.fromTo(parent, {
                            xPercent: 5,
                            autoAlpha: 0
                        }, {
                            xPercent: 0,
                            autoAlpha: 1
                        });

                        return field
                    }
                },
                hide(selectEl) {
                    if (!isElement(selectEl)) return;

                    const {field, parent} = this.getBound(selectEl);

                    if (field && parent) {
                        const selectId = selectEl.getAttribute('id');

                        if (!selectId || !selectEl.savedNameAttr) return;

                        selectEl.setAttribute('name', selectEl.savedNameAttr);
                        field.removeAttribute('name');

                        gsap.fromTo(parent, {
                            xPercent: 0,
                            autoAlpha: 1
                        }, {
                            xPercent: 5,
                            autoAlpha: 0,
                            onComplete: () => {
                                $dom.addClass(parent, 'd-none');
                                field.value = '';
                            }
                        })
                    }
                }
            }

            this.handleSelectOtherChoice = event => {
                const {detail, target} = event;
                const {value} = detail.choice;

                if (value === 'other') {
                    this.otherField.show(target);
                } else {
                    this.otherField.hide(target);
                }
            }

            $dom.each(this.targets, this.addField);

            $events.delegate.on('choice', withOtherFieldSelectSelector, this.handleSelectOtherChoice)
        },
		onDestroy() {
            Object.values(this.fields).forEach(ch => {
                if(ch instanceof Choices) ch.destroy();
            });

            this.fields = {};
        }
	})
}
